<template>
  <QToolbar>
    <QToolbarTitle class="flex container">
      <div class="full-width">
        <img v-if="organisationLogo" class="brand-logo" :src="organisationLogo" alt="Scoreboard" style="max-height: 60px" />
      </div>
      <div class="full-width">
        <img
          v-if="fleetPartnerLogo && !isMMBA"
          class="brand-logo pull-right"
          :src="fleetPartnerLogo"
          alt="Scoreboard"
          style="max-height: 60px"
        />
      </div>
    </QToolbarTitle>
  </QToolbar>
</template>

<script>
import { QToolbar, QToolbarTitle } from 'eclipx.ui';
import { mapGetters, mapState } from 'vuex';
import appConfig from '../../utils/app-config';
/**
 * This component represents the header which is to be displayed as part of all page layouts.
 */
export default {
  name: 'Header',
  props: {
    title: String
  },
  data() {
    return {
      organisationLogoPlaceholder: `${process.env.BASE_URL}assets/logos/fleetpartners_logo.svg`,
      fleetPartnerLogoPlaceholder: `${process.env.BASE_URL}assets/logos/fleetpartners_logo.svg`
    };
  },
  computed: {
    ...mapState({
      scoreboard: (state) =>
        state.vehicleApplication?.vehicleApplication?.scoreboard ? state.vehicleApplication?.vehicleApplication?.scoreboard : null
    }),
    ...mapGetters({
      orgProfile: 'theme/getScoreboard',
      whitelabel: 'theme/getWhitelabel'
    }),
    organisationLogo() {
      if (this.orgProfile?.primaryLogo) {
        return this.orgProfile.primaryLogo;
      }
      return null;
    },
    fleetPartnerLogo() {
      if (this.orgProfile?.primaryLogoRight) {
        return this.orgProfile.primaryLogoRight;
      }
      return null;
      /*return this.fleetPartnerLogoPlaceholder;*/
    },
    isMMBA() {
      if (this.whitelabel?.abn === '53007870395' || this.whitelabel?.introducer?.abn === '53007870395') {
        return true;
      }
      return false;
    }
  },
  methods: {
    logout() {
      this.$router.push({ name: 'logout' });
    },
    goToHome() {
      this.$router.push({ name: 'home' });
    }
  },
  components: {
    QToolbar,
    QToolbarTitle
  }
};
</script>

<style lang="sass" scoped>
.brand-logo
  height: 26px
.q-toolbar
  min-height: 39px;
.full-width
  position: relative;
  min-width: 1px;
  max-width: 100%;
  flex: 1;
.pull-right
  float: right;
</style>
